import React from 'react';
import classNames from 'classnames';
import { Heading } from '../../components';

// cowork24 renders these as an Airbnb-style icon grid instead of upstream's PropertyGroup,
// so AmenityIcon and its styles moved here together with the component in v10.12.0.
import AmenityIcon from './AmenityIcon';
import css from './CustomExtendedDataSection.module.css';

const SectionMultiEnum = props => {
  const {
    heading,
    options,
    selectedOptions,
    idPrefix,
    className,
    rootClassName,
    showUnselectedOptions = true,
  } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }

  const selected = selectedOptions || [];
  const items = showUnselectedOptions
    ? options
    : options.filter(o => selected.includes(o.key));

  const classes = classNames(rootClassName || css.sectionMultiEnum, className);

  return (
    <section className={classes}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.amenitiesGrid} aria-label={heading}>
        {items.map(option => {
          const isSelected = selected.includes(option.key);
          return (
            <li
              key={option.key}
              className={classNames(css.amenityItem, {
                [css.amenityItemMuted]: !isSelected,
              })}
            >
              <span className={css.amenityIcon}>
                <AmenityIcon optionKey={option.key} label={option.label} />
              </span>
              <span className={css.amenityLabel}>
                {isSelected ? option.label : <s>{option.label}</s>}
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionMultiEnum;
